import { Component, Input, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { DevicesService, StateService, AppService } from '@services';

/*Models */
import { DailyQuality, Device, GraphQuality } from '@models';

/*Plugins */

/*Plugins */
import { IMyDrpOptions, IMyDateRangeModel } from 'mydaterangepicker';
import * as moment from 'moment';

import { Chart, Highcharts } from 'angular-highcharts';

/*Config*/
import { CONFIG } from '@config';

@Component({
	selector: 'app-report-quality-graph',
	templateUrl: './report-quality-graph.component.html',
	styleUrls: ['./report-quality-graph.component.scss']
})

export class ReportQualityGraphComponent implements OnInit {
    @Input("data") graphData: GraphQuality;
    green = "#87cc57";
    yellow = "#fdd14a";
    red = "#e94b26";

    chartBlock: Chart;
    chartTooltip = {
        // Формат для обычных данных
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}'
      };
    chartYAxis = {
        // Формат для обычных данных
        min: 0,
        max:100,
        title: {
          text: null
        },
        tickInterval: 20,
         labels: {
          formatter: function () {
            return `${this.value}`;
          }
        }
      };
    constructor(private appService: AppService){}

    ngOnInit(){
        this.initChart()
    }


    initChart(){
        const data = [];
        const legend = [];
        const colors = []
        
        this.parseFormatDataChart().map(item => {
          legend.push(this.getDateFormat(item[0]));
          data.push(item[1]);
          if(item[1]<=15){
            colors.push(this.red);
        }else if(item[1]>15 && item[1]<90){
            colors.push(this.yellow);
        }else{
            colors.push(this.green);
        }
        });

        console.log(legend)
        console.log(data)

        this.chartBlock = this.getChart([{name: 'Уровень', data: data,  pointWidth: 15}], legend, this.chartYAxis, this.chartTooltip, colors);
    }


  parseFormatDataChart() {
    let dataArray = [];

    this.graphData.items.map((item, index ) => {
        let newItem;
        newItem = [ moment.unix(item.timeStamp).format('DD.MM.YYYY'), item.score, item.timeStamp];
        dataArray.push(newItem);
    });

    dataArray = this.appService.sortedArray(dataArray, 2);
    
    return dataArray;
  }

  getChart(series, legend, yAxis, tooltip, colors: Array<string>) {
    return new Chart({
      chart: {
        type: 'column',
        marginBottom: 50
      },
      title: { style: { 'display': 'none' } },
      xAxis: {
        categories: legend,
        
      },
      colors: colors,
      yAxis: yAxis,
      tooltip: tooltip,
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          pointWidth: 15,
          colorByPoint: true
        },
      },


      series: series,
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
    });
  }


  getDateFormat(date: string) {
    const dateArray = date.split('.');
    return `${dateArray[0]}.${dateArray[1]}`;
  }

}





// WEBPACK FOOTER //
// ./src/app/view/components/report-quality-graph/report-quality-graph.component.ts